module.exports = __webpack_public_path__ + "static/media/icon_placeholder_no-pipeline-data.eada1448.svg";